// Shared bits for the training video library (mig 291): categories, the YouTube ID parser used for
// the form preview, and the player. The SERVER parses the link again and is the authority — this
// copy only lets HR see the right video before saving.
import React from 'react';
import { HRC } from './hrkit';

export const CATEGORIES = [
  ['induction', 'Induction'], ['safety', 'Safety'], ['machine_operation', 'Machine operation'],
  ['quality', 'Quality'], ['erp_how_to', 'ERP how-to'], ['maintenance', 'Maintenance'],
  ['compliance', 'Compliance'], ['other', 'Other'],
];
export const categoryLabel = (k) => (CATEGORIES.find(c => c[0] === k) || [k, k])[1];

const ID = /^[A-Za-z0-9_-]{11}$/;
const HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be', 'www.youtu.be',
  'youtube-nocookie.com', 'www.youtube-nocookie.com'];
export function youtubeId(input) {
  const s = String(input || '').trim();
  if (!s) return null;
  if (ID.test(s)) return s;
  let u;
  try { u = new URL(/^https?:\/\//i.test(s) ? s : 'https://' + s); } catch { return null; }
  const host = u.hostname.toLowerCase();
  if (!HOSTS.includes(host)) return null;
  const parts = u.pathname.split('/').filter(Boolean);
  let cand = null;
  if (host.endsWith('youtu.be')) cand = parts[0];
  else if (parts[0] === 'watch') cand = u.searchParams.get('v');
  else if (['embed', 'shorts', 'live', 'v'].includes(parts[0])) cand = parts[1];
  return cand && ID.test(cand) ? cand : null;
}

// Thumbnails come from YouTube's image host, which sets no cookies.
export const thumbUrl = (id) => `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
// youtube-nocookie.com (ruled 2026-09-17): no YouTube cookies until the viewer presses play.
export const embedUrl = (id) => `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;

export const Departments = ({ item }) => (
  <span style={{ fontSize: 11, color: HRC.muted }}>
    {item.for_all_departments ? 'All departments' : (item.departments || []).map(d => d.name).join(' · ') || '—'}
  </span>
);

// 16:9 player. The iframe is built from the stored ID only, so the host it frames is fixed here.
export const Player = ({ youtubeId: id, title }) => (
  <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', background: '#000', borderRadius: 8, overflow: 'hidden' }}>
    <iframe src={embedUrl(id)} title={title} allowFullScreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }} />
  </div>
);
